import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getToken } from "@/lib/api";
import { toast } from "sonner";

export default function AcceptInvitePage() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      sessionStorage.setItem("halfjob_pending_invite", code);
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/households/invites/accept", { code });
        toast.success("Joined household");
        navigate("/household", { replace: true });
      } catch (e) {
        const status = e?.response?.status;
        const detail = e?.response?.data?.detail || "Could not accept invite";
        if (status === 403) {
          // Not approved — bounce to request-access waitlist
          toast.message("This invite requires beta access.");
          navigate("/request-access", { replace: true });
          return;
        }
        toast.error(detail);
        navigate("/household", { replace: true });
      }
    })();
  }, [code, navigate]);

  return <div className="p-6 text-timber-700" data-testid="accept-invite-page">Joining household…</div>;
}
